import imgEmptyNoData from 'assets/images/img_emptyview_no_data.png';
import AccountHelper from 'features/Account/accountHelper';
import AgencyHelper from 'features/Agency/agencyHelper';
import ChargeHelper from 'features/Charge/chargeHelper';
import SetKPIView, { SetKPIViewHelper } from 'features/ManageDealer/components/SetKPIView';
import DealerHelper from 'features/ManageDealer/dealerHelper';
import { AppDialogHelper } from 'general/components/AppDialog';
import BreadcrumbHelper from 'general/components/CustomBreadcrumb/BreadcrumbHelper';
import DropdownFilterTable from 'general/components/DropdownFilterTable';
import DropdownTableConfigColumn from 'general/components/DropdownTableConfigColumn';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTBSButton, {
  KTBSButtonColor,
  KTBSButtonSize,
} from 'general/components/OtherKeenComponents/KTBSButton';
import KTBSCard from 'general/components/OtherKeenComponents/KTBSCard';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import KTDropdownFilter from 'general/components/OtherKeenComponents/KTDropdownFilter';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import KTPagination, {
  KTPaginationColor,
} from 'general/components/OtherKeenComponents/KTPagination';
import KTTable from 'general/components/OtherKeenComponents/KTTable';
import tableStyle from 'general/components/OtherKeenComponents/KTTable/tableStyle';
import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';
import CustomDateRangePicker, {
  dateFilter,
  getDateFilterOption,
} from 'general/components/Others/CustomDateRangePicker';
import EmptyView from 'general/components/Others/EmptyView';
import MenuActionDropdown from 'general/components/Others/MenuActionDropdown';
import VITableRowDropDown from 'general/components/VITableRowDropDown';
import AppColors from 'general/constants/AppColors';
import AppConstants from 'general/constants/AppConstants';
import AppResource from 'general/constants/AppResource';
import ToastHelper from 'general/helpers/ToastHelper';
import Global from 'general/utils/Global';
import Utils from 'general/utils/Utils';
import useConfigTableColumn from 'hooks/useConfigTableColumn';
import useRouter from 'hooks/useRouter';
import moment from 'moment';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const defaultColumnIds = [
  'DEALER_CODE',
  'DEALER_NAME',
  'DEALER_LEVEL',
  'DEALER_TYPE',
  'PARENT_DEALER',
  'OPERATOR',
  'PHONE',
  'EMAIL',
  'TAXCODE/CCCD',
  'REVENUE',
  'BALANCE',
  'STATUS',
  'ADDRESS',
  'CREATEDBY',
  'DATE',
];

function DealerListScreen(props) {
  // ---- params ----
  const { t } = useTranslation();
  const router = useRouter();
  const { user, permissionList } = useSelector((state) => state.auth);
  const [operatorList, setOperatorList] = useState([]);
  const [filter, setFilter] = useState(Global.g_filterDealerList);
  const [filterDropdown, setFilterDropdown] = useState(Global.g_filterDealerList);

  // khu vuc
  const areaTree = useSelector((state) => state.app.areaTree);
  const areaProvinceList = useMemo(() => {
    return ChargeHelper.Utils.getAreaListByType([areaTree], 'P');
  }, [areaTree]);
  const areaProvinceOptions = useMemo(() => {
    return _.map(areaProvinceList, (item) => {
      return {
        name: item.name,
        value: item.areaId,
      };
    });
  }, [areaProvinceList]);
  const [selectedAreaProvince, setSelectedAreaProvince] = useState();
  const areaDistrictList = useMemo(() => {
    if (!selectedAreaProvince) return [];
    return ChargeHelper.Utils.getSubAreaListByParentId([areaTree], selectedAreaProvince?.areaId);
  }, [areaTree, selectedAreaProvince]);
  const areaDistrictOptions = useMemo(() => {
    return _.map(areaDistrictList, (item) => {
      return {
        name: item.name,
        value: item.areaId,
      };
    });
  }, [areaDistrictList]);
  const [selectedAreaDistrict, setSelectedAreaDistrict] = useState();
  useEffect(() => {
    const areaId = filterDropdown.areaId;
    if (Utils.isValid(areaId)) {
      const area = ChargeHelper.Utils.getAreaById([areaTree], areaId);
      if (area?.typeCode === 'P') {
        setSelectedAreaProvince(area);
      } else {
        setSelectedAreaDistrict(area);
        const parentAreaId = area?.parentId;
        if (Utils.isValid(parentAreaId)) {
          setSelectedAreaProvince(ChargeHelper.Utils.getAreaById([areaTree], parentAreaId));
        }
      }
    }
  }, [filterDropdown?.areaId, areaTree]);

  const app = useSelector((state) => state.app);
  const { isGettingData, saleList, saleTotal } = useSelector((state) => state.agency);
  const adminRole =
    user?.role === AppConstants.userRole.admin || user?.role === AppConstants.userRole.operator;

  const fullColumns = useMemo(() => {
    return [
      {
        id: 'DEALER_CODE',
        name: (
          <span
            className="letter-spacing-unset"
            style={{
              fontSize: 12,
              color: AppColors.gray[900],
            }}
          >
            {t('Mã đại lý')}
          </span>
        ),
        selector: (row) => row?.agencyCode ?? (row.agencyId),
        style: tableStyle.columns.normal,
        sortable: false,
        width: '120px',
      },
      {
        id: 'DEALER_NAME',
        name: (
          <span
            className="letter-spacing-unset"
            style={{
              fontSize: 12,
              color: AppColors.gray[900],
            }}
          >
            {t('Tên đại lý')}
          </span>
        ),
        minWidth: '240px',
        selector: (row) => {
          return (
            <KTTooltip offset={[0, 0]} text={row?.name ?? ''}>
              <span>{row?.name ?? ''}</span>
            </KTTooltip>
          );
        },
        style: tableStyle.columns.normal,
        sortable: false,
      },
      {
        id: 'DEALER_LEVEL',
        name: (
          <span
            className="letter-spacing-unset"
            style={{
              fontSize: 12,
              color: AppColors.gray[900],
            }}
          >
            {t('Cấp đại lý')}
          </span>
        ),
        selector: (row) => {
          return (
            <span className="min-w-100px">
              <KTLabel
                text={DealerHelper.getAgencyLevel(row?.deepLevel)}
                isInline={true}
                size={KTLabelSize.medium}
                additionalClassName={`label-light-primary`}
              />
            </span>
          );
        },
        style: tableStyle.columns.normal,
        sortable: false,
        width: '120px',
      },
      {
        id: 'DEALER_TYPE',
        name: (
          <span
            className="letter-spacing-unset"
            style={{
              fontSize: 12,
              color: AppColors.gray[900],
            }}
          >
            {t('Loại đại lý')}
          </span>
        ),
        selector: (row) => t(row.type) ?? 'N/A',
        style: tableStyle.columns.normal,
        sortable: false,
        width: '100px',
      },
      {
        id: 'PARENT_DEALER',
        name: (
          <span
            className="letter-spacing-unset"
            style={{
              fontSize: 12,
              color: AppColors.gray[900],
            }}
          >
            {t('Đại lý quản lý')}
          </span>
        ),
        selector: (row) => {
          return (
            <KTTooltip offset={[0, 0]} text={row?.parentAgency?.name}>
              <span
                className="cursor-pointer hover-opacity-60"
                onClick={() => {
                  DealerHelper.navigateToParentAgency(row?.parentAgency);
                }}
              >
                {row?.parentAgency?.name}
              </span>
            </KTTooltip>
          );
        },
        style: tableStyle.columns.link,
        minWidth: '240px',
      },
      {
        id: user?.role !== AppConstants.userRole.operator ? 'OPERATOR' : '',
        name: (
          <span
            className="letter-spacing-unset"
            style={{
              fontSize: 12,
              color: AppColors.gray[900],
            }}
          >
            {t('operator')}
          </span>
        ),
        selector: (row) =>
          operatorList.length > 0
            ? operatorList.find((operator) => operator.operatorId === row.operatorId)?.name
            : '',
        style: tableStyle.columns.normal,
        sortable: false,
        minWidth: '150px',
      },
      {
        id: 'PHONE',
        name: (
          <span
            className="letter-spacing-unset"
            style={{
              fontSize: 12,
              color: AppColors.gray[900],
            }}
          >
            {t('phone')}
          </span>
        ),
        selector: (row) => row.phone ?? '',
        style: tableStyle.columns.normal,
        sortable: false,
        width: '140px',
      },
      {
        id: 'EMAIL',
        name: (
          <span
            className="letter-spacing-unset"
            style={{
              fontSize: 12,
              color: AppColors.gray[900],
            }}
          >
            {t('email')}
          </span>
        ),
        selector: (row) => {
          return (
            <KTTooltip offset={[0, 0]} text={row?.email ?? ''}>
              <span>{row?.email ?? ''}</span>
            </KTTooltip>
          );
        },
        style: tableStyle.columns.normal,
        minWidth: '250px',
      },
      {
        id: 'TAXCODE/CCCD',
        name: (
          <span
            className="letter-spacing-unset"
            style={{
              fontSize: 12,
              color: AppColors.gray[900],
            }}
          >
            {t('MST/CCCD')}
          </span>
        ),
        selector: (row) =>
          row.type === AppConstants.accountType.individual
            ? row.idCardNumber?.length > 0
              ? row.idCardNumber
              : row.taxCode?.length > 0
                ? row.taxCode
                : ''
            : row.taxCode?.length > 0
              ? row.taxCode
              : '',
        style: tableStyle.columns.normal,
        sortable: false,
        width: '150px',
      },
      {
        id: 'REVENUE',
        name: (
          <div className="w-100 d-flex flex-column align-items-end">
            <div
              className="letter-spacing-unset"
              style={{
                fontSize: 12,
                color: AppColors.gray[900],
              }}
            >
              {t('Tổng doanh thu')}
            </div>
            <div
              className="letter-spacing-unset font-weight-bold"
              style={{ color: AppColors.gray[700] }}
            >
              VNĐ
            </div>
          </div>
        ),
        selector: (row) => Utils.formatNumber(row?.revenue),
        width: '150px',
        right: true,
        style: tableStyle.columns.normal,
        sortable: false,
      },
      {
        id: 'BALANCE',
        name: (
          <div className="w-100 d-flex flex-column align-items-end">
            <div
              className="letter-spacing-unset"
              style={{
                fontSize: 12,
                color: AppColors.gray[900],
              }}
            >
              {t('Số dư ví')}
            </div>
            <div
              className="letter-spacing-unset font-weight-bold"
              style={{ color: AppColors.gray[700] }}
            >
              VNĐ
            </div>
          </div>
        ),
        selector: (row) => Utils.formatNumber(row?.balance) ?? 0,
        width: '160px',
        right: true,
        style: tableStyle.columns.normal,
        sortable: false,
      },
      {
        id: 'STATUS',
        name: (
          <span
            className="letter-spacing-unset"
            style={{
              fontSize: 12,
              color: AppColors.gray[900],
            }}
          >
            {t('status')}
          </span>
        ),
        selector: (row) => {
          return (
            <KTLabel
              text={t(`agencyStatus_${row.status}`)}
              isInline={true}
              size={KTLabelSize.medium}
              additionalClassName={`label-light-${DealerHelper.getAgencyStatusColor(row.status)}`}
            />
          );
        },
        sortable: false,
        minWidth: '130px',
      },
      {
        id: 'ADDRESS',
        name: (
          <span
            className="letter-spacing-unset"
            style={{
              fontSize: 12,
              color: AppColors.gray[900],
            }}
          >
            {t('Địa chỉ')}
          </span>
        ),
        selector: (row) => {
          const area = ChargeHelper.Utils.getAreaById([areaTree], row?.areaId);
          let parentArea;
          if (area?.typeCode === 'W') {
            parentArea = ChargeHelper.Utils.getAreaById([areaTree], area?.parentId);
          }
          const addressResuslt = [row.address, area?.name, parentArea?.name]
            .filter(Boolean)
            .join(', ');
          return (
            <KTTooltip text={addressResuslt} offset={[0, 0]}>
              <span>{addressResuslt?.length > 0 ? addressResuslt : ''}</span>
            </KTTooltip>
          );
        },
        style: tableStyle.columns.normal,
        sortable: false,
        minWidth: '250px',
      },
      {
        id: 'CREATEDBY',
        name: (
          <span
            className="letter-spacing-unset"
            style={{
              fontSize: 12,
              color: AppColors.gray[900],
            }}
          >
            {t('Người tạo')}
          </span>
        ),
        selector: (row) => {
          return (
            <KTTooltip offset={[0, 0]} text={row?.createdBy?.fullname ?? row?.name}>
              <span
                className="cursor-pointer hover-opacity-60"
                onClick={() => {
                  DealerHelper.navigateToParentAgency(row?.createdBy ?? row);
                }}
              >
                {row?.createdBy?.fullname ?? row?.name}
              </span>
            </KTTooltip>
          );
        },
        style: tableStyle.columns.link,
        sortable: false,
        width: '200px',
      },
      {
        id: 'DATE',
        name: (
          <span
            className="letter-spacing-unset"
            style={{
              fontSize: 12,
              color: AppColors.gray[900],
            }}
          >
            {t('Ngày tạo')}
          </span>
        ),
        selector: (row) => Utils.formatDateTimeToString(row.createdAt, 'DD/MM/YYYY - HH:mm'),
        style: tableStyle.columns.normal,
        sortable: false,
        width: '160px',
      },
      {
        name: (
          <span
            className="letter-spacing-unset"
            style={{
              fontSize: 12,
              color: AppColors.gray[900],
            }}
          >
            {t('actions')}
          </span>
        ),
        width: '130px',
        style: {
          position: 'sticky',
          right: 0,
          backgroundColor: '#fff',
          borderLeft: '1px solid #ebedfe',
        },
        wrap: true,
        cell: (row) => {
          return (
            <MenuActionDropdown
              menuAction={[
                {
                  iconElement: (
                    <i
                      className="fa-regular fa-eye"
                      style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                    ></i>
                  ),
                  text: t('Xem chi tiết'),
                  click: () => {
                    handleClickedRow(row);
                  },
                  show: Utils.checkPermission(permissionList, AppConstants.permissionCode.saleView.code),
                },
                {
                  iconElement: (
                    <i
                      className="fa-regular fa-bolt"
                      style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                    ></i>
                  ),
                  text: t('Kích hoạt tài khoản'),
                  click: () => {
                    DealerHelper.handleAcceptAgency(row, () => {
                      getDealerList(filter);
                    });
                  },
                  show: row?.status === 'REGISTERED' && Utils.checkPermission(permissionList, AppConstants.permissionCode.saleUpdate.code),
                },
                {
                  iconElement: (
                    <i
                      className="fa-regular fa-pen-to-square"
                      style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                    ></i>
                  ),
                  text: t('edit'),
                  click: () => {
                    handleShowEditAgency(row);
                  },
                  show: (!row?.numberOfSignedContracts || adminRole) && Utils.checkPermission(permissionList, AppConstants.permissionCode.saleUpdate.code),
                },
                {
                  iconElement: (
                    <i
                      className="fa-regular fa-plus-circle"
                      style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                    ></i>
                  ),
                  text: t('addOrder'),
                  click: () => {
                    if (row?.numberOfSignedContracts && row?.numberOfSignedContracts > 0) {
                      BreadcrumbHelper.setBreadcrumPath(
                        t('Tạo đơn hàng'),
                        `${router?.pathname}/${row?.agencyId}/agency-add-order`
                      );
                      router.navigate(`add-order?sale=${row?.agencyId}`);
                    } else {
                      DealerHelper.showDialogCreateContract(row);
                    }
                  },
                  show: row?.status === 'NORMAL' && Utils.checkPermission(permissionList, AppConstants.permissionCode.saleUpdate.code),
                },
                {
                  iconElement: (
                    <i
                      className="far fa-square"
                      style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                    ></i>
                  ),
                  text: t('stopWorking'),
                  click: () => {
                    DealerHelper.handleStopAgency(row, () => {
                      getDealerList(filter);
                    });
                  },
                  show: row?.status === 'NORMAL' && Utils.checkPermission(permissionList, AppConstants.permissionCode.saleUpdate.code),
                },
                {
                  iconElement: (
                    <i
                      className="far fa-play"
                      style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                    ></i>
                  ),
                  text: t('unStopWorking'),
                  click: () => {
                    DealerHelper.handleActiveAgency(row, () => {
                      getDealerList(filter);
                    });
                  },
                  show: row?.status === 'SUSPENDED' && Utils.checkPermission(permissionList, AppConstants.permissionCode.saleUpdate.code),
                },
                {
                  iconElement: (
                    <i
                      className="far fa-bullseye-arrow"
                      style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                    ></i>
                  ),
                  text: t('Thiết lập KPI tháng'),
                  click: () => {
                    DealerHelper.setMonthKPI(row, () => {
                      getDealerList(filter);
                    });
                  },
                  show: row?.status !== 'REGISTERED' && row?.parentAgencyId && Utils.checkPermission(permissionList, AppConstants.permissionCode.saleUpdate.code),
                },
                {
                  iconElement: (
                    <i
                      className="fa-regular fa-file-contract"
                      style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                    ></i>
                  ),
                  text: 'Tạo hợp đồng CTV',
                  click: () => {
                    // AgencyHelper.UI.showDialogConfirmCreateContractWithSale(row, () => {});
                    AgencyHelper.UI.showDialogConfirmCreateContractWithAgency(row, () => { });
                  },
                  show:
                    row?.status !== 'REGISTERED' &&
                    row?.parentAgencyId &&
                    Utils.checkPermission(permissionList, AppConstants.permissionCode.saleUpdate.code),
                },
                {
                  iconElement: (
                    <i
                      className={`fa-regular fa-lock`}
                      style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                    ></i>
                  ),
                  text: t('Đặt lại mật khẩu'),
                  click: () => {
                    DealerHelper.showDialogChangePassword(row, () => {
                      getDealerList(filter);
                    });
                  },
                  show: adminRole && Utils.checkPermission(permissionList, AppConstants.permissionCode.saleUpdate.code),
                },
                {
                  iconElement: (
                    <i
                      className={`fa-regular fa-trash-can`}
                      style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                    ></i>
                  ),
                  text: t('Xóa đại lý'),
                  click: () => {
                    DealerHelper.handleDeleteAgency(row, () => {
                      getDealerList(filter);
                    });
                  },
                  show: !row?.numberOfSignedContracts && row?.parentAgencyId && Utils.checkPermission(permissionList, AppConstants.permissionCode.saleDelete.code),
                },
              ]}
            />
          );
        },
      },
    ];
  }, [t, operatorList, areaTree, user, filter]);

  const prefKey = useMemo(() => {
    const userId = user.userId;
    const pathName = router.pathname;
    const key = `${userId}_${pathName}`;
    return key;
  }, [user, router]);
  const [fullColumnIds, setFullColumnIds] = useState(
    fullColumns.filter(column => !column.omit).map(column => column.id).filter(Boolean) || []
  );
  const {
    columnIds,
    columns,
    onChangeCheckboxValue,
    saveChanges,
    resetDefaultTableColumn,
    onSelectAll,
    onUnSelectAll,
    fullColumnsSorted,
    fullColumnsIdSorted,
  } = useConfigTableColumn(prefKey, fullColumnIds, defaultColumnIds, fullColumns);

  const classifyOperators = (operators) => {
    setOperatorList(
      operators?.map((operator) => ({ operatorId: operator.operatorId, name: operator.name }))
    );
  };

  useEffect(() => {
    if (app.appConfig) {
      classifyOperators(app.appConfig.operators ?? []);
    }
  }, [app.appConfig]);

  useEffect(() => {
    getDealerList({ ...filter, parentAgencyId: adminRole ? '' : user?.agency?.agencyId });
  }, [filter]);

  const getDealerList = () => {
    try {
      DealerHelper.callApiGetAgencyList(filter);
    } catch (error) {
      ToastHelper.showError(error?.response?.data?.reason);
    }
  };

  // ---- methods ----
  const handleClickedRow = (row) => {
    BreadcrumbHelper.setBreadcrumPath(t('dealerDetail'), `${router?.pathname}/${row?.agencyId}`);
    router.navigate(`${row.agencyId}`);
  };

  //them dai ly
  const handleOpenAddDealerModal = () => {
    BreadcrumbHelper.setBreadcrumPath(t('addDealer'), `${router?.pathname}/add`);
    router.navigate('add');
  };

  const handleShowEditAgency = (row) => {
    BreadcrumbHelper.setBreadcrumPath(
      t('Chỉnh sửa đại lý'),
      `${router?.pathname}/${row?.agencyId}/edit`
    );
    router.navigate(`${row?.agencyId}/edit`);
  };

  // xoa dai ly
  const handleDeleteAgency = (id) => {
    AppDialogHelper.show(
      t('deleteAgency'),
      t('textConfirmDeleteAgency'),
      [
        {
          title: t('cancel'),
          type: 'neutral',
          onClick: () => {
            AppDialogHelper.hide();
          },
        },
        {
          title: t('delete'),
          type: 'negative',
          onClick: async () => {
            AppDialogHelper.hide();
            const isSuccess = await DealerHelper.callApiDeleteAgency(id);
            if (isSuccess) {
              ToastHelper.showSuccess(t('deleteAgencySuccess'));
              DealerHelper.callApiGetAgencyList(filter);
            } else {
              console.log(t('deleteAgencyFailed'));
            }
          },
        },
      ],
      false,
      AppResource.images.dialogIcons.dialogDeleteVehicle
    );
  };

  const updateFilter = (key, value) => {
    Global.g_filterDealerList = { ...Global.g_filterDealerList, [key]: value };
    setFilter(Global.g_filterDealerList);
    setFilterDropdown(Global.g_filterDealerList);
  };

  const FilterComponentList = ({ isInDropdown = false }) => (
    <div className={`${isInDropdown ? 'row' : 'w-100'} d-flex  flex-row  flex-wrap`}>
      {/* nha dieu hanh */}
      {/*  <KTDropdownFilter
          label={t('operator')}
          filterKey="operatorId"
          options={[
            { name: t('all'), value: '' },
            ...operatorList?.map((operator) => ({
              name: operator.name,
              value: operator.operatorId,
            })),
          ]}
          selectedValue={!isInDropdown ? Global.g_filterDealerList.operatorId : filterDropdown.operatorId}
          isInDropdown={isInDropdown}
          additionalClassName={`${isInDropdown ? 'pr-2' : 'pr-0'}`}
        /> */}

      {/* cap dai ly */}
      <KTDropdownFilter
        label={t('dealerLevel')}
        filterKey="level"
        options={DealerHelper.filterAgencyLevelOptions()}
        selectedValue={
          !isInDropdown ? Global.g_filterDealerList.deepLevel : filterDropdown.deepLevel
        }
        isInDropdown={isInDropdown}
        additionalClassName={`${isInDropdown ? 'pr-2 pt-4' : 'pl-0 pr-4'}`}
        handleChange={(value) => {
          if (isInDropdown) {
            setFilterDropdown({ ...filterDropdown, deepLevel: value });
          } else {
            updateFilter('deepLevel', value);
            updateFilter('page', 0);
          }
        }}
      />

      {/* loai dai ly */}
      <KTDropdownFilter
        label={t('agencyType')}
        filterKey="type"
        options={DealerHelper.filterAgencyTypeOptions()}
        selectedValue={!isInDropdown ? Global.g_filterDealerList.type : filterDropdown.type}
        isInDropdown={isInDropdown}
        additionalClassName={`${isInDropdown ? 'pl-2 pt-4' : 'pl-0 pr-4'}`}
        handleChange={(value) => {
          if (isInDropdown) {
            setFilterDropdown({ ...filterDropdown, type: value });
          } else {
            updateFilter('type', value);
            updateFilter('page', 0);
          }
        }}
      />

      {/* <KTDropdownFilter
        label={t('Đại lý quản lý')}
        filterKey="deepLevel"
        options={DealerHelper.filterLevelOptions('SALE')}
        selectedValue={isInDropdown ? filterDropdown.deepLevel : Global.g_filterDealerList.deepLevel}
        isInDropdown={isInDropdown}
        additionalClassName={`${isInDropdown ? 'pr-2' : 'pr-4'}`}
        handleChange={(value) => {
          if (isInDropdown) {
            setFilterDropdown({ ...filterDropdown, deepLevel: value });
          } else {
            updateFilter('deepLevel', value);
            updateFilter('page', 0);
          }
        }}
      /> */}

      {/* trang thai */}
      <KTDropdownFilter
        label={t('status')}
        filterKey="status"
        options={DealerHelper.filterStatusOptions()}
        selectedValue={
          !isInDropdown
            ? Global.g_filterDealerList.status ||
            (Global.g_filterDealerList.hasSignedContract ? AppConstants.agencyStatus.signed : '')
            : filterDropdown.status ||
            (Global.g_filterDealerList.hasSignedContract || filterDropdown.hasSignedContract
              ? AppConstants.agencyStatus.signed
              : '')
        }
        isInDropdown={isInDropdown}
        additionalClassName={`${isInDropdown ? 'pr-2 pt-2' : 'pl-0 pr-0 pr-xl-4'}`}
        handleChange={(value) => {
          const isSigned = value === 'SIGNED';
          const newStatus = isSigned ? '' : value;
          const newHasSignedContract = isSigned ? 1 : '';

          if (isInDropdown) {
            setFilterDropdown({
              ...filterDropdown,
              status: newStatus,
              hasSignedContract: newHasSignedContract,
            });
          } else {
            updateFilter('status', newStatus);
            updateFilter('hasSignedContract', newHasSignedContract);
            updateFilter('page', 0);
          }
        }}
      />

      {isInDropdown && (
        <>
          <KTDropdownFilter
            label={t('Người tạo')}
            filterKey="createdBy"
            options={DealerHelper.filterCreatedByOptions()}
            selectedValue={filterDropdown.createdBy}
            isInDropdown={isInDropdown}
            additionalClassName="pl-2 pt-2"
            handleChange={(value) => {
              if (isInDropdown) {
                setFilterDropdown({ ...filterDropdown, createdBy: value });
              } else {
                updateFilter('createdBy', value);
              }
            }}
          />

          <div className="col-12 py-2">
            <label htmlFor="filterByDate" className="mb-0 mr-2 font-weight-bolder">
              {t('Khoảng thời gian thống kê')}
            </label>
            <CustomDateRangePicker
              toggleElementBorderRadius={5}
              alignRight={true}
              initialValue={
                filterDropdown.selectedValue.length > 0
                  ? filterDropdown.selectedValue
                  : dateFilter.tatCaThoiGian
              }
              onPressSave={(selectedValue, startDate, endDate) => {
                const updateFilterDropdown = {
                  ...filterDropdown,
                  from: startDate,
                  to: endDate,
                  selectedValue: selectedValue,
                };
                setFilterDropdown(updateFilterDropdown);
              }}
              filterComponent={filterDropdown}
            />
          </div>

          <KTDropdownFilter
            label={t('city')}
            filterKey="areaId"
            options={areaProvinceOptions}
            selectedOption={selectedAreaProvince}
            selectedValue={filterDropdown.areaId}
            isInDropdown={isInDropdown}
            additionalClassName="pr-2 pt-2"
            searchable={true}
            handleChange={(value) => {
              const province = _.find(areaProvinceList, (item) => item.areaId === value);
              setSelectedAreaProvince(province);
              setSelectedAreaDistrict('');
              if (isInDropdown) {
                setFilterDropdown({ ...filterDropdown, areaId: value });
              } else {
                updateFilter('areaId', value);
              }
            }}
          />

          <KTDropdownFilter
            label={t('district')}
            filterKey="areaId"
            options={areaDistrictOptions}
            selectedOption={selectedAreaDistrict}
            selectedValue={filterDropdown.areaId}
            isInDropdown={isInDropdown}
            additionalClassName="pl-2 pt-2"
            searchable={true}
            handleChange={(value) => {
              setSelectedAreaDistrict(_.find(areaDistrictList, (item) => item.areaId === value));
              if (isInDropdown) {
                setFilterDropdown({ ...filterDropdown, areaId: value });
              } else {
                updateFilter('areaId', value);
              }
            }}
          />
        </>
      )}
    </div>
  );

  return (
    <div className='m-4'>
      <KTBSCard
        borderRadius="10"
        title={t('dealerList')}
        description={
          <div>
            <span
              className="font-weight-bolder"
              style={{ fontSize: '14px', color: AppColors.gray[800] }}
            >
              {t('total')}:{' '}
            </span>
            <span
              className="font-weight-bolder"
              style={{ fontSize: '14px', color: AppColors.primary }}
            >
              {saleTotal != 0 ? saleTotal : saleList.length} {t('dealer')}
            </span>
          </div>
        }
        additionalHeaderClassName="pt-4 pb-2"
        additionalBodyClassName=""
        additionalFooterClassName=""
        hideDividerHeader
        hideDividerFooter
        toolbar={
          <div className="d-flex gap-3">
            {/* <KTBSButton
              title={t('delete')}
              size={KTBSButtonSize.small}
              color={KTBSButtonColor.danger}
              iconElement={<i className="fa-regular fa-minus" />}
            /> */}
            <KTBSButton
              color={KTBSButtonColor.primary}
              title={t('Tải xuống')}
              size={KTBSButtonSize.default}
              borderRadius={5}
              buttonTitleFontWeight="600"
              iconElement={<i className="fa-regular fa-download" style={{ fontSize: 15 }} />}
              onPress={() => console.log('Tải xuống')}
              height={43}
              buttonTitleFontSize={14}
            />
            {Utils.checkPermission(permissionList, AppConstants.permissionCode.saleCreate.code) && (
              <KTBSButton
                color={KTBSButtonColor.success}
                title={t('addDealer')}
                size={KTBSButtonSize.default}
                borderRadius={5}
                buttonTitleFontWeight="600"
                iconElement={<i className="fa-regular fa-circle-plus" style={{ fontSize: 15 }} />}
                onPress={handleOpenAddDealerModal}
                height={43}
                buttonTitleFontSize={14}
              />
            )}
          </div>
        }
        subToolbar={
          <div className="w-100 d-flex align-items-end flex-wrap">
            <div className={`col-lg-3 pl-0 py-2 pr-0 pr-xl-4 pr-lg-4`}>
              <label htmlFor="search" className="mb-0 mr-2 font-weight-bolder">
                {t('search')}
              </label>
              <KTFormSearch
                name="search-bar"
                placeholder={t('Theo mã đại lý, tên đại lý, số điện thoại, email, MST/CCCD...')}
                value={Global.g_filterDealerList.q}
                onSubmit={(text) => {
                  Global.g_filterDealerList = {
                    ...Global.g_filterDealerList,
                    q: text,
                    page: 0,
                  };
                  setFilter(Global.g_filterDealerList);
                  setFilterDropdown(Global.g_filterDealerList);
                }}
              />
            </div>
            <div className="col-xl-7 col-lg-9 px-0">
              <FilterComponentList />
            </div>

            {/* bo loc */}
            <div className="py-2 pr-4">
              <DropdownFilterTable
                filterComponent={[
                  <div className={`${'col-12 p-0'}`}>
                    <KTFormSearch
                      name="search-bar"
                      placeholder={t(
                        'Theo mã đại lý, tên đại lý, số điện thoại, email, MST/CCCD...'
                      )}
                      value={filterDropdown.q}
                      onSubmit={(text) => {
                        const updateFilterDropdown = { ...filterDropdown, q: text };
                        setFilterDropdown(updateFilterDropdown);
                      }}
                    />
                  </div>,
                  <FilterComponentList
                    isInDropdown={true}
                    onChange={(filter) => {
                      setFilterDropdown({
                        ...filterDropdown,
                        ...filter,
                      });
                    }}
                  />,
                ]}
                resetDefaultTable={() => {
                  const updateFilterDropdown = {
                    ...filterDropdown,
                    q: '',
                    type: '',
                    status: '',
                    from: getDateFilterOption(dateFilter.tatCaThoiGian)[0].format('YYYY-MM-DD'),
                    to: getDateFilterOption(dateFilter.tatCaThoiGian)[1].format('YYYY-MM-DD'),
                    selectedValue: dateFilter.tatCaThoiGian,
                    areaId: '',
                    createdBy: '',
                    deepLevel: '',
                    hasSignedContract: '',
                  };
                  setFilterDropdown(updateFilterDropdown);
                  setFilter(updateFilterDropdown);
                  Global.g_filterDealerList = updateFilterDropdown;
                  setSelectedAreaProvince('');
                  setSelectedAreaDistrict('');
                }}
                saveFilter={() => {
                  setFilter(filterDropdown);
                  Global.g_filterDealerList = filterDropdown;
                }}
                isDefaultFilter={Utils.checkDefaultFilter(
                  ['role', 'page', 'limit', 'from', 'to', 'selectedValue'],
                  filter
                )}
              />
            </div>
            {/* cau hinh cot */}
            <div className="pr-0 py-2">

            </div>
          </div>
        }
        footer={
          <KTPagination
            currentPage={filter.page + 1}
            rowCount={saleTotal != 0 ? saleTotal : saleList.length}
            rowsPerPage={filter.limit}
            currentItemInPageCount={saleList.length}
            onChangePage={(newPage) => {
              const iNewPage = parseInt(newPage);
              Global.g_filterDealerList = {
                ...Global.g_filterDealerList,
                page: iNewPage - 1,
              };
              setFilter(Global.g_filterDealerList);
            }}
            onChangeRowsPerPage={(newRowsPerPage) => {
              const iNewRowsPerPage = parseInt(newRowsPerPage);
              Global.g_filterDealerList = {
                ...Global.g_filterDealerList,
                limit: iNewRowsPerPage,
                page: 0,
              };
              setFilter(Global.g_filterDealerList);
            }}
            loading={isGettingData}
            color={KTPaginationColor.success}
            appendText="đại lý"
          />
        }
        body={
          <KTTable
            columns={columns}
            items={saleList}
            selectableRows={false}
            striped={false}
            compactGrid={false}
            onClickedRow={(row) => { }}
            onSelectedRowsChanged={(rows) => { }}
            onDoubleClickedRow={(rows) => { }}
            noDataComponent={
              <EmptyView
                icon={imgEmptyNoData}
                title="Không có dữ liệu để hiển thị"
                text={<span>Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.</span>}
              />
            }
          />
        }
      />
    </div>
  );
}

export default DealerListScreen;
